<section class="header">
  <div class="top-buttons">
    <app-button
      [icon]="'event'"
      [size]="'icon-very-small'"
      (click)="showCalendars()"
    ></app-button>
    <app-button
      [icon]="'add'"
      [size]="'icon-very-small'"
      (click)="hourClickedInWeekView()"
    ></app-button>
    <app-button
      [icon]="'refresh'"
      [size]="'icon-very-small'"
      (click)="synchronizeAppointments()"
    ></app-button>
  </div>

  <div class="row text-center">
    <div class="col-md-4">
      <div class="btn-group">
        <button
          class="calendar-button"
          mat-icon-button
          mwlCalendarPreviousView
          [view]="view"
          [(viewDate)]="viewDate"
          (viewDateChange)="closeOpenMonthViewDay()"
        >
          <mat-icon>chevron_left</mat-icon>
        </button>
        <button
          class="calendar-button"
          mat-icon-button
          mwlCalendarToday
          [(viewDate)]="viewDate"
        >
          <mat-icon>today</mat-icon>
        </button>
        <button
          class="calendar-button"
          mat-icon-button
          mwlCalendarNextView
          [view]="view"
          [(viewDate)]="viewDate"
          (viewDateChange)="closeOpenMonthViewDay()"
        >
          <mat-icon>chevron_right</mat-icon>
        </button>
      </div>
    </div>
    <div class="col-md-4">
      <h3>
        {{
          viewDate
            | calendarDate
              : (view === "week" ? "month" : view) + "ViewTitle"
              : "it"
        }}
      </h3>
    </div>
    <div class="col-md-4">
      <div class="btn-group">
        <button
          class="calendar-button"
          mat-icon-button
          (click)="setView(CalendarView.Month)"
          [class.active]="view === CalendarView.Month"
        >
          <mat-icon>calendar_view_month</mat-icon>
        </button>
        <button
          class="calendar-button"
          mat-icon-button
          (click)="setView(CalendarView.Week)"
          [class.active]="view === CalendarView.Week"
        >
          <mat-icon>calendar_view_week</mat-icon>
        </button>
        <button
          class="calendar-button"
          mat-icon-button
          (click)="setView(CalendarView.Day)"
          [class.active]="view === CalendarView.Day"
        >
          <mat-icon>calendar_view_day</mat-icon>
        </button>
      </div>
    </div>
  </div>
</section>
<br />
<div [ngSwitch]="view" class="calendar-content" #scrollContainer>
  <mwl-calendar-month-view
    *ngSwitchCase="CalendarView.Month"
    [locale]="locale"
    [weekStartsOn]="weekStartsOn"
    [viewDate]="viewDate"
    [events]="events"
    [refresh]="refresh"
    [activeDayIsOpen]="activeDayIsOpen"
    (dayClicked)="dayClicked($event.day)"
    (eventClicked)="handleEvent('Clicked', $event.event)"
    (eventTimesChanged)="eventTimesChanged($event)"
  >
  </mwl-calendar-month-view>
  <mwl-calendar-week-view
    *ngSwitchCase="CalendarView.Week"
    [locale]="locale"
    [viewDate]="viewDate"
    [dayStartHour]="dayStartHour"
    [dayEndHour]="dayEndHour"
    [weekStartsOn]="weekStartsOn"
    [hourSegments]="1"
    [hourSegmentHeight]="44"
    [events]="events"
    [refresh]="refresh"
    (hourSegmentClicked)="hourClickedInWeekView($event)"
    (eventClicked)="handleEvent('Clicked', $event.event)"
    (eventTimesChanged)="eventTimesChanged($event)"
  >
  </mwl-calendar-week-view>
  <mwl-calendar-day-view
    *ngSwitchCase="CalendarView.Day"
    [locale]="locale"
    [viewDate]="viewDate"
    [events]="events"
    [refresh]="refresh"
    [dayStartHour]="dayStartHour"
    [dayEndHour]="dayEndHour"
    (eventClicked)="handleEvent('Clicked', $event.event)"
    (eventTimesChanged)="eventTimesChanged($event)"
    (hourSegmentClicked)="hourClickedInWeekView($event)"
  >
  </mwl-calendar-day-view>

  <app-add-new-patient-panel
    *ngIf="showAddEventPanel"
    [title]="'new_interview'"
    [onlyNewAppointment]="true"
    (cancel)="hourClickedInWeekView()"
    (confirm)="hourClickedInWeekView()"
  ></app-add-new-patient-panel>
</div>
<app-calendars-info-panel
  *ngIf="showCalendarsGoogle"
  [calendars]="calendars"
  (close)="showCalendars()"
></app-calendars-info-panel>
